class ShareSocial extends HTMLElement {
    constructor() {
        super();
    }

    static get observedAttributes() {
        return ["open"];
    }

    get current() {
        return this.getAttribute("open");
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "open" && newValue === "true" && oldValue === "false") {
            this.openPanel();
        }

        if (name === "open" && newValue === "false" && oldValue === "true") {
            this.closePanel();
        }
    }

    connectedCallback() {
        this.button = this.querySelector("#share-social-component");
        this.toggleHandle = this.toggle.bind(this);
        this.openHandler = this.open.bind(this);
        this.closeHandler = this.close.bind(this);
        this.keyupHandler = this.keyup.bind(this);

        this.button.addEventListener("click", this.toggleHandle);
        this.addEventListener("mouseenter", this.openHandler);
        this.addEventListener("mouseleave", this.closeHandler);
        document.addEventListener("keyup", this.keyupHandler);
    }

    toggle(event) {
        const state = this.current === "true" ? true : this.current === "false" ? false : false;
        this.setAttribute("open", !state);
    }

    open() {
        if (this.getAttribute("open") === "true") return;
        this.setAttribute("open", "true");
    }

    close() {
        if (this.getAttribute("open") === "false") return;

        this.setAttribute("open", "false");
    }

    openPanel() {
        this.button.setAttribute("aria-expanded", "true");
    }

    closePanel() {
        this.button.setAttribute("aria-expanded", "false");
    }

    keyup(event) {
        if (this.getAttribute("open") === "false" && event.code.toUpperCase() === "ESCAPE") return;
        if (this.getAttribute("open") === "true" && event.code.toUpperCase() === "ESCAPE") {
            this.close();
        }
    }
}

customElements.define("share-social", ShareSocial);
